import { Observable } from 'rxjs';
import { NotificationService } from '../../services';
import { BaseCondition } from './base.condition';

export class WithdrawInvitationCondition extends BaseCondition {
  constructor(options: any, notificationService: NotificationService) {
    super("WithdrawInvitationCondition", notificationService);
    const defaultTimeoutValue = 10;
    let timeoutValue = (options.WithdrawSec && !isNaN(options.WithdrawSec)) ? options.WithdrawSec : defaultTimeoutValue;
    console.info('[WithdrawInvitationCondition] Invitation Withdraw timeout (sec) ->', timeoutValue);
    this.observable = new Observable(observer => {
      // resolve to true in N seconds
      const timer = setTimeout(() => {
        console.info('[WithdrawInvitationCondition] Timeout has occurred, withdrawing invitation.');
        observer.next(true);
      }, timeoutValue * 1000);

      // teardown logic
      return () => clearTimeout(timer);
    });
  }
}
